import { render, staticRenderFns } from "./DashboardViewOrder.vue?vue&type=template&id=85ba78c2&"
import script from "./DashboardViewOrder.vue?vue&type=script&lang=js&"
export * from "./DashboardViewOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports